export function generateInitialFormValues(user) {
  const formValues = {
    userName: user.username,
    firstName: user.firstName,
    lastName: user.lastName,
    nationality: user.nationality,
    city: user.address.city,
    zip: user.address.zip,
    streetAndNumber: user.address.street,
    country: user.address.country,
    dayOfBirthday: user.birthday.day,
    monthOfBirthday: user.birthday.month,
    yearOfBirthday: user.birthday.year,
    pep: user.pep
  };

  if (user.refs) {
    const refsKeys = Object.keys(user.refs);

    refsKeys.forEach(ref => {
      formValues[ref] = user.refs[ref];
    });
  }

  return formValues;
}
